module.exports = __webpack_public_path__ + "static/media/cr-tool.query.e4fb2cfb.graphql";